import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

import { SOCIAL_TYPE } from '@shared/const';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const SocialIcon = ({ name, ...props }) => {
  let Icon;
  switch (name) {
    case SOCIAL_TYPE.FACEBOOK:
      Icon = lazy(() => import('@mui/icons-material/Facebook'));
      break;
    case SOCIAL_TYPE.INSTAGRAM:
      Icon = lazy(() => import('@mui/icons-material/Instagram'));
      break;
    case SOCIAL_TYPE.TWITTER:
      Icon = lazy(() => import('@mui/icons-material/X'));
      break;
    case SOCIAL_TYPE.LINKEDIN:
      Icon = lazy(() => import('@mui/icons-material/LinkedIn'));
      break;
    case SOCIAL_TYPE.YOUTUBE:
      Icon = lazy(() => import('@mui/icons-material/YouTube'));
      break;
    default:
      return null;
  }

  return (
    <Suspense fallback={<CheckBoxOutlineBlankIcon {...props} />}>
      <Icon {...props} />
    </Suspense>
  );
};

SocialIcon.propTypes = {
  name: PropTypes.oneOf(Object.values(SOCIAL_TYPE)).isRequired,
};

export default SocialIcon;
